import React from "react";
import { Button, Result } from "antd";
import { trackJsError } from "services/UsageTrackingService";

type ErrorBoundaryProps = { children: React.ReactNode };
type ErrorBoundaryState = { hasError: boolean };

/**
 * Captura crashes de render (que antes viravam tela branca sem nenhum sinal),
 * registra como JS_ERROR na telemetria e exibe um fallback com recuperação.
 */
class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    trackJsError({
      message: error?.message,
      stack: error?.stack,
      componentStack: info?.componentStack,
      origin: "react-error-boundary",
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="error"
          title="Ocorreu um erro inesperado"
          subTitle="O erro foi registrado. Recarregue a página para continuar."
          extra={[
            <Button
              type="primary"
              key="reload"
              onClick={() => window.location.reload()}
            >
              Recarregar
            </Button>,
          ]}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
